import { Modal, type ModalProps, TextSubHeader } from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';
import { EditJsonForm, type EditJsonFormProps } from './EditJsonForm';

export type EditJsonModalProps = Pick<ModalProps, 'open'> & EditJsonFormProps;

export const EditJsonModal = ({
  open,
  onCancel,
  onSubmit,
  value,
}: EditJsonModalProps) => {
  return (
    <Modal
      zIndex={getMaxZIndex() + 1}
      open={open}
      title={
        <TextSubHeader
          label="Edit JSON Data"
          color="text-ds-natural-600"
        />
      }
      onClose={onCancel}
    >
      <EditJsonForm
        onCancel={onCancel}
        onSubmit={onSubmit}
        value={value}
      />
    </Modal>
  );
};
